import {HttpClient, HttpHeaders, HttpRequest} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {ApiConfig} from '../core/config/api.config';
import {BASE_SERVICE} from '../core/config/api.constants';
import {endpoint} from './path.constants';
import {ApiResponse} from './api-response.model';
import {Gender} from './enum/enum.model';
import {States} from './enum/city-state.model';


@Injectable({providedIn: 'root'})
export class BaseService {
  private readonly baseUrl = ApiConfig.getBaseUrl(BASE_SERVICE);

  constructor(private http: HttpClient) {
  }

  getBaseEnum() {
    const headers = new HttpHeaders(ApiConfig.secretKeyHeader());
    return this.http.get<ApiResponse<{ gender_type: Gender[] }>>(
      this.baseUrl + endpoint.base.enum, {headers}
    );
  }

  getCityState() {
    const headers = new HttpHeaders(ApiConfig.secretKeyHeader());
    return this.http.get<ApiResponse<States>>(
      this.baseUrl + endpoint.base.city_state, {headers}
    );
  }

  uploadFile(file: File) {
    const headers = new HttpHeaders(ApiConfig.secretKeyHeader());
    const formData = new FormData();
    formData.append('file', file);
    formData.append('public', 'True');
    const req = new HttpRequest('POST', this.baseUrl + endpoint.base.upload_file, formData, {
      headers,
      reportProgress: true,
    });
    return this.http.request(req);
  }

}
